<ng-container *ngFor="let identificationType of internalTypes">
  <div class="identification-card">
    <div class="identification-card__content" [ngClass]="{'identification-card__content--unselected': isNotSelected(identificationType)}">
      <div class="identification-card__image">
        <img class="identification-card__svg" [alt]="identificationType" src="/assets/svg/{{identificationType}}.svg" />
      </div>
      <div class="identification-card__instructions">
        <div class="identification-card__title">
          {{ ('CHOOSE_IDENTIFICATION_TITLE_' + identificationType) | translate }}
        </div>
        <div class="identification-card__description">
          {{ ('CHOOSE_IDENTIFICATION_DESCRIPTION_' + identificationType) | translate }}
        </div>
      </div>
    </div>
    <div class="identification-card__action" *ngIf="internalTypes?.length > 1">
      <button [id]="buttonId(identificationType)" class="btn" (click)="onSelectIdentificationType(identificationType)">
        {{ 'CHOOSE_IDENTIFICATION_CHOOSE_ACTION' | translate }}
      </button>
    </div>
  </div>
</ng-container>
